import styled from 'styled-components'
import variables from '../../styles/variables'

export const ContainerEditProfile = styled.div`
    width: 100%;
    margin: 2rem 0;
    i{
        margin: 0;
        cursor: pointer;
        text-align: center;
        color: ${variables.greenHight};
        font-size: 1.5rem;
    }
`